import { useState, forwardRef, useImperativeHandle } from 'react';
import styles from './Index.module.css';
import { IconArrowLeftAlt } from '../Icons';

export const PopUpIframe = forwardRef(({ url, title }, ref) => {
    const [showPopUp, setShowPopUp] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);

    // Expor métodos open e close via ref
    useImperativeHandle(ref, () => ({
        open: () => openPopUp(),
        close: () => closePopUp()
    }));

    const openPopUp = () => {
        document.documentElement.style.overflow = "hidden";
        setShowPopUp(true);
    };

    const closePopUp = () => {
        document.documentElement.style.overflow = "auto";
        setShowPopUp(false);
        setPageLoaded(false); // opcional: reinicia o loader
    };

    const handleLoad = () => {
        setPageLoaded(true);
    };

    return url && showPopUp && (
        <section className={styles.ContainerEscuro}>
            <section className={styles.Container}>
                <section className={styles.ContainerNav}>
                    <IconArrowLeftAlt
                        onClick={closePopUp}
                        size={32}
                        color='var(--cor_tooMe)'
                    />
                    <h2>{title}</h2>
                </section>
                {!pageLoaded && <div className={styles.Loader}></div>}
                <iframe
                    src={url}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer"
                    onLoad={handleLoad}
                />
            </section>
        </section>
    );
});